import {
  changeBible,
  getParallels,
  addParallel as addParallelUtil,
  removeParallel as removeParallelUtil,
  removeAllParallels as removeAllParallelsUtil,
  chapterPath,
  getPassageId
} from "utils/paths";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { isTabletDevice, isMobileDevice } from "utils/mobile";
import { useMemo } from "react";

export const getMaxNumParallels = () => {
  if (isTabletDevice()) return 1;
  else if (isMobileDevice()) return 0;
  return 2;
};

export const useScriptureRouting = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch<{
    bibleId: string;
    chapterId: string;
  }>("/bible/:bibleId/:chapterId");

  const { bibleId = "", chapterId = "" } = match?.params || {};
  const parallelBibleIds = useMemo(() => getParallels(location.search), [
    location.search
  ]);

  const setBible = (params: { bibleId: string; parallelIndex?: number }) => {
    if (!match) return;
    const { bibleId, parallelIndex } = params;
    history.push(changeBible({ match, location, bibleId, parallelIndex }));
  };

  const setChapter = (params: { bibleId?: string; chapterId: string }) => {
    const { bibleId: paramsBibleId, chapterId } = params;
    history.push(
      chapterPath({
        bibleId: paramsBibleId || bibleId,
        chapterId,
        location
      })
    );
  };

  const addParallel = () => {
    if (!bibleId) return;
    if (parallelBibleIds.length < getMaxNumParallels()) {
      history.push(addParallelUtil({ parallelId: bibleId, location }));
    }
  };

  const removeParallel = (parallelIndex: number) => {
    history.push(removeParallelUtil({ parallelIndex, location }));
  };

  const removeAllParallels = () => {
    history.push(removeAllParallelsUtil({ location }));
  };

  const passageId = getPassageId({ location });

  return {
    bibleId,
    chapterId,
    passageId,
    setBible,
    setChapter,
    addParallel,
    removeParallel,
    removeAllParallels,
    parallelBibleIds
  };
};
